export const STATUS_TYPES = {
  0: {
    text: '待审批',
    color: 'info'
  },
  1: {
    text: '已审核',
    color: 'success'
  },
  2: {
    text: '审核不通过',
    color: 'warning'
  }
};
export const PAGINATION = {
  page: 1,
  size: 10
};
